import styled, { css } from 'styled-components';

import { colorsMatrix, fonts, Link } from '@dreryk/react-components';

export const StyledLink = styled(Link)`
   font-weight: ${fonts.fontWeightBold};
   color: ${colorsMatrix.green.darker};

   &:hover {
      ${(props) => css`
         color: ${props.theme.successDarker};
         fill: ${props.theme.successDarker};
      `}
   }
`;

StyledLink.displayName = 'StyledLink';
